import { SVGIcon } from "@progress/kendo-svg-icons";

export const pauseIcon: SVGIcon = {
  name: "pause-custom",
  content: '<path d="M64 64h128v384H64zm256 0h128v384H320z" />',
  viewBox: "0 0 512 512",
};
